import { SuspendModificationReason } from "../const/suspend-modification-reason";

export default {
  appId: (state) => state.appId,
  isDev: (state) => state.user.isDev,
  isMobile: (state) => state.isMobile,
  isPartner: (state) => state.user.isPartner,
  isDemo: (state) => state.isDemo,
  timezone: (state) => state.timezone,
  lang: (state) => state.user.lang,
  email: (state) => state.user.email,
  currency: (state) => state.user.currency,
  companyUrl: (state) => state.user.companyUrl,
  trackerId: (state) => state.trackerId,
  roles: (state) => state.user.roles,
  trackers: (state) => state.user.trackers,
  hasRole: (state) => (roleName) => state.user.roles[roleName] === true,
  isSuperagent: (state) => state.user.roles.ROLE_SUPER_AGENT === true,
  isMfaEnabled: (state) => state.user.isMfaEnabled === true,
  isLoadingOverlayVisible: (state) => state.layout.isLoadingOverlayVisible,
  trackerPlatform: (state) => state.tracker.platform,
  trackerConfiguration: (state) => state.tracker.configuration,
  dynamicElementPriceFormatTypeId: (state) => state.tracker.configuration.dynamicElementPriceFormatTypeId,
  isSuspendedAdministrative: (state) => {
    return (
      state.tracker.lifecycle.isSuspended &&
      state.tracker.lifecycle.suspendModificationReasonId === SuspendModificationReason.Administrative
    );
  },
  isSuspendedBillingPlan: (state) => {
    return (
      state.tracker.lifecycle.isSuspended &&
      state.tracker.lifecycle.suspendModificationReasonId === SuspendModificationReason.BillingPlanExceeded
    );
  },
  isSuspendedTrialExceeded: (state) => {
    return (
      state.tracker.lifecycle.isSuspended &&
      state.tracker.lifecycle.suspendModificationReasonId === SuspendModificationReason.TrialExceeded
    );
  },
  isSuspendedOverdueInvoices: (state) => {
    return (
      state.tracker.lifecycle.isSuspended &&
      state.tracker.lifecycle.suspendModificationReasonId === SuspendModificationReason.OverdueInvoices
    );
  },
};
